import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { StepIndex } from './DashboardTour';
import { useDashboardTourContext } from './DashboardTourContext';
import { useMutationObserver } from './useMutationObserver';

const useStyles = makeStyles((_theme) => ({
  spotlight: {
    borderRadius: 4,
    backgroundColor: 'gray',
    pointerEvents: 'auto',
    transition: 'opacity 0.2s ease 0s',
  },
  extraSpotlightInnerPage: {
    position: 'absolute',
    height: 1838,
    left: 265,
    opacity: 1,
    top: 66,
    width: '100%',
  },
}));

const JOYRIDE_OVERLAY_CLASS = 'react-joyride__overlay';

export function DashboardTourExtraSpotlights() {
  const classes = useStyles();

  const [joyrideOverlay, setJoyrideOverlay] = useState<Element | undefined>();

  const {
    state: { run, stepIndex },
  } = useDashboardTourContext();

  const onDocumentBodyMutation = useCallback(
    (mutations) => {
      if (!run) return;

      mutations.forEach((mutation) => {
        for (const node of mutation.removedNodes) {
          if (node?.classList?.contains(JOYRIDE_OVERLAY_CLASS)) {
            setJoyrideOverlay(undefined);
            break;
          }
        }

        for (const node of mutation.addedNodes) {
          if (node?.classList?.contains(JOYRIDE_OVERLAY_CLASS)) {
            setJoyrideOverlay(node);
            break;
          }
        }
      });
    },
    [run]
  );

  useMutationObserver(document.body, onDocumentBodyMutation, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });

  const addExtraSpotlights = (...classNames) =>
    run && joyrideOverlay ? (
      <>
        {classNames.map((className) =>
          ReactDOM.createPortal(
            <div
              className={`react-joyride__spotlight ${classes.spotlight} ${className}`}
            />,
            joyrideOverlay
          )
        )}
      </>
    ) : null;

  // MANAGER - manage account
  if (
    stepIndex === StepIndex.ACCOUNT_SETTINGS_TAB ||
    stepIndex === StepIndex.MANAGE_TEAMS_TAB ||
    stepIndex === StepIndex.MANAGE_AGENTS_TAB ||
    stepIndex === StepIndex.MANAGE_NUMBERS_TAB ||
    stepIndex === StepIndex.MANAGE_QUEUES_TAB ||
    stepIndex === StepIndex.REPORTING_QUEUES_TAB
    // stepIndex === StepIndex.EDIT_AGENT_TAB ||
    // stepIndex === StepIndex.POWERLISTS_TAB ||
    // stepIndex === StepIndex.SMS_TEMPLATE_TAB ||
    // stepIndex === StepIndex.VM_DROP_TAB ||
    // stepIndex === StepIndex.AGENT_SNAPSHOT_TAB
  ) {
    return addExtraSpotlights(classes.extraSpotlightInnerPage);
  }

  return null;
}
